import {observable, action} from 'mobx';
import {endpoints, types} from 'shared/core';
import {PerformanceReviewReview} from 'stores/performance_reviews';
import {DomainStore} from 'shared/store';

class IncompleteManagerRevieweesState {
  store = new DomainStore();

  @observable cycle;
  @observable incompleteManagerReviews = [];

  receiveProps({cycle}) {
    this.cycle = cycle;
  }

  @action async load() {
    if (!this.cycle.managerType) return;

    await this.store._compose(
      endpoints.PERFORMANCE_REVIEWS.INCOMPLETE_MANAGER_REVIEWS.with(this.cycle.id)
    );

    this.incompleteManagerReviews = this.store._getAll(
      types.PERFORMANCE_REVIEWS.REVIEW,
      PerformanceReviewReview
    );
  }
}

export default IncompleteManagerRevieweesState;
